import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { HardHat, Wrench } from "lucide-react";
import { EmptyState, PageHeader } from "@/components/shared/Common";
import { api } from "@/lib/api";
import { clp } from "@/lib/format";

export const LIGHT = { verde: ["#258F00", "Al día"], amarillo: ["#c99700", "En riesgo"], rojo: ["#b42318", "Atrasada"] };

export const Bar = ({ planned, real }) => (
  <div className="relative h-2.5 rounded-full bg-[#eef1ec] overflow-hidden">
    <div className="absolute inset-y-0 left-0 bg-[#cfe9c0]" style={{ width: `${planned}%` }} />
    <div className="absolute inset-y-0 left-0 bg-[#258F00] rounded-full" style={{ width: `${real}%` }} />
  </div>
);

export default function OpsBoard() {
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/operaciones/board").then((r) => setList(r.data)); }, []);
  return (
    <div data-testid="ops-board-page">
      <PageHeader eyebrow="Operaciones" title="Tarjetas OT" subtitle="Avance real contra el planificado, semáforo de atraso, dotación en faena hoy y consumo." />
      {!list ? <div className="text-[#5b6656]">Cargando…</div> : list.length === 0 ? <div className="syc-card"><EmptyState title="Sin OT en ejecución" /></div> : (
        <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-4">{list.map((o) => (
          <Link key={o.id} to={`/operaciones/ot/${o.id}`} data-testid={`ops-card-${o.id}`} className="syc-card p-5 block transition-transform hover:-translate-y-0.5" style={{ borderTop: `4px solid ${LIGHT[o.light][0]}` }}>
            <div className="flex items-start justify-between gap-2"><div className="min-w-0"><div className="font-mono text-xs text-[#5b6656]">{o.code}</div><div className="font-bold truncate">{o.title}</div></div>
              <span className="text-xs font-bold px-2 py-0.5 rounded-full text-white" style={{ background: LIGHT[o.light][0] }} data-testid={`ops-light-${o.id}`}>{LIGHT[o.light][1]}</span></div>
            <div className="mt-4 flex items-end justify-between"><div><div className="text-3xl font-extrabold" data-testid={`ops-real-${o.id}`}>{o.real}%</div><div className="text-xs text-[#5b6656]">real · plan {o.planned}%</div></div>
              <div className="text-right text-xs text-[#5b6656]">{o.tasks} tareas{o.late_tasks ? <div className="text-[#b42318] font-semibold">{o.late_tasks} atrasadas</div> : null}{!o.baseline && <div>sin línea base</div>}</div></div>
            <div className="mt-3"><Bar planned={o.planned} real={o.real} /></div>
            <div className="mt-4 flex flex-wrap gap-4 text-xs text-[#5b6656]"><span className="flex items-center gap-1"><HardHat size={13} />{o.present_today} en faena</span>
              <span className="flex items-center gap-1"><Wrench size={13} />{o.tools_out} herramientas</span>{o.consumption !== undefined && <span>Materiales {clp(o.consumption)}</span>}</div>
          </Link>))}</div>)}
    </div>
  );
}
